import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ca05c98&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterGroups: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Footer/FooterGroups.vue').default,FooterCredits: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Footer/FooterCredits.vue').default,FooterDocuments: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Footer/FooterDocuments.vue').default,FooterLicense: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Footer/FooterLicense.vue').default,Footer: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Footer/index.vue').default})
